import React from 'react';
import PropTypes from 'prop-types';
import { MentionsInput, Mention } from 'react-mentions';
import { Popover } from 'antd';
import TitleAutocomplete from '../../../Title/TitleAutocomplete';
import classNames from 'classnames';
import './commentInputWithMentioning.less';
import { Translate } from '@above-the-treeline/localization';

CommentInputWithMentioning.propTypes = {
	className: PropTypes.string,
	placeholderText: PropTypes.string,
	comment: PropTypes.string,
	onChangeEvent: PropTypes.func,
	isOnModal: PropTypes.bool,
};

CommentInputWithMentioning.defaultProps = {
	isOnModal: false,
};

function CommentInputWithMentioning({
	className,
	placeholderText,
	comment,
	onChangeEvent,
	isOnModal,
}) {
	const [text, setText] = React.useState(comment || '');
	const [isTagging, setIsTagging] = React.useState(false);
	const [plainText, setPlainText] = React.useState('');
	const [mentions, setMentions] = React.useState([]);
	const [textInput, setTextInput] = React.useState(null);
	const setTextInputRef = element => {
		setTextInput(element);
	};

	const onChange = (e, newValue, plainText, allMentions) => {
		setTextValue(newValue);
		setIsTagging(plainText[textInput.selectionStart - 1] === '@');
		setMentions(allMentions);
		setPlainText(plainText);
	};

	const setTextValue = value => {
		setText(value);
		if (typeof onChangeEvent === 'function') onChangeEvent(value);
	};

	const mentionTitleInComment = (sku, instance) => {
		const caretIndex = textInput.selectionStart;
		const titleTag = `[${instance.selectedDisplayName}](${sku})`;
		const textToSave = insertTitleIntoComment(caretIndex, titleTag);
		setTextValue(textToSave);
		setIsTagging(false);
		textInput.focus();
	};

	const getTitleTagInsertionIndex = caretIndex => {
		let insertionIndex = caretIndex;
		const specialCharacterCount = 5;
		mentions.forEach(mention => {
			let indicesToAddForMarkup =
				mention.id.length + specialCharacterCount;
			if (mention.index < insertionIndex) {
				insertionIndex += indicesToAddForMarkup;
			}
		});
		return insertionIndex;
	};

	const insertTitleIntoComment = (caretIndex, titleTag) => {
		let commentWithTitle;
		if (plainText.length === caretIndex) {
			commentWithTitle = `${text}${titleTag}`;
		} else {
			let insertionIndex = getTitleTagInsertionIndex(caretIndex);
			commentWithTitle =
				text.slice(0, insertionIndex) +
				titleTag +
				text.slice(insertionIndex);
		}
		return commentWithTitle;
	};

	const autocompleteClasses = classNames(
		'comment-frame-autocomplete-popover',
		{
			'is-on-modal': isOnModal,
			'is-not-on-modal': !isOnModal,
		},
	);

	return (
		<Popover
			visible={isTagging}
			destroyTooltipOnHide={true}
			overlayClassName={autocompleteClasses}
			content={
				<TitleAutocomplete
					placeholder={
						<Translate id="click_here_to_search_for_titles" />
					}
					onSelectOption={mentionTitleInComment}
					autoFocus={true}
				/>
			}>
			<div onClick={() => setIsTagging(false)} className={className}>
				<MentionsInput
					className="comments-text-area"
					placeholder={placeholderText}
					value={text}
					onChange={onChange}
					inputRef={setTextInputRef}>
					<Mention data={[]} />
				</MentionsInput>
			</div>
		</Popover>
	);
}

export default CommentInputWithMentioning;
